<!--
* UIID: UI-DLB-CT-110
* UI Name: Code Data Pool
* Modify Date: 2020/07/31
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
    style="width: 1200px !important; top: 0 !important"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.dbBroker.queryPool.pageHeader') }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <!-- [S]  Data Section-->
    <v-row class="ma-0" style="height: 548px">
      <!-- [S]  left component-->
      <v-col cols="" class="pa-0">
        <v-card-text class="pa-0 data-section code-data-pool">
          <v-row class="ma-0">
            <!-- [S]  first table-->
            <v-col class="pa-0">
              <v-row class="ma-0 pr-4">
                <v-col lg="2" class="comm-header-col date-query-section pb-0 pl-0 pt-0"> </v-col>
                <v-col
                  lg="10"
                  class="d-inline-flex comm-header-col date-query-section pb-0 pr-0 pt-0 mt-0"
                >
                  <div>
                    <v-text-field
                      v-model="queryPoolItems.QR_NM"
                      class="data-table-filter-text-field search-button-data-analysis-table"
                      height="30"
                      :placeholder="$t('lbl.dbBroker.queryNm')"
                      outlined
                      hide-details
                      dense
                      solo
                      @keyup.enter="queryPool"
                      style="width: 200px"
                    ></v-text-field>
                  </div>
                  <div class="pl-2">
                    <v-select
                      v-model="queryPoolItems.QR_DB"
                      :items="searchNameDBList"
                      @change="queryPool()"
                      class="search-by data-table-select-box custom-selectbox flat-file-selectbox"
                      height="30"
                      hide-details
                      dense
                      solo
                      style="width: 160px"
                    ></v-select>
                  </div>
                  <div class="pl-2">
                    <v-select
                      v-model="queryPoolItems.QR_TP"
                      :items="searchTypeDBList"
                      @change="queryPool()"
                      class="search-by data-table-select-box custom-selectbox flat-file-selectbox"
                      height="30"
                      hide-details
                      dense
                      solo
                      style="width: 160px"
                    ></v-select>
                  </div>
                  <div class="pl-2 pr-0">
                    <v-text-field
                      v-model="queryPoolItems.QR_TXT"
                      class="data-table-filter-text-field search-button-data-analysis-table"
                      height="30"
                      :placeholder="$t('lbl.dbBroker.queryTxt')"
                      outlined
                      hide-details
                      dense
                      solo
                      @keyup.enter="queryPool"
                      style="width: 369px"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row class="ma-0 padding-code-table">
                <v-col class="pa-0">
                  <hot-table ref="hotTableComponent" :settings="hotSettings"> </hot-table>
                </v-col>
              </v-row>
            </v-col>
            <!-- [E]  first table-->
          </v-row>
        </v-card-text>
      </v-col>
      <!-- [E]  left component-->
    </v-row>
    <!-- // 2021.11.26 203728 SPKA-281 modify paging  -->
    <v-row class="custom-pagination-figma-v3-last pl-3 mb-4 pr-7">
      <v-col class="page-control-content page-control-bg transaction-pagi custom-popup-v3">
        <v-row>
          <v-col
            v-show="totalCount > 0"
            class="page-control-bg text-left custom-popup-v3 pa-0"
            cols="6"
          >
            <div class="custom-pagi-selectbox m-1">
              <v-select
                v-model="itemsPerPage"
                :items="rowPerPage"
                @change="queryPool()"
                class="data-table-select-box custom-selectbox page-flat-file-selectbox pt-2"
                hide-details
                dense
                solo
              ></v-select>
            </div>
          </v-col>
          <v-col
            v-show="totalCount > 0"
            class="page-control-bg text-end custom-popup-v3 pa-0 pt-1"
            cols="6"
          >
            <div class="page-showing">
              <v-label>
                {{ itemsPerPage * (page - 1) + 1 }} ~
                {{ totalCount - itemsPerPage * page > 0 ? itemsPerPage * page : totalCount }} of
                {{ totalCount }}
              </v-label>
            </div>
            <!-- 2021.11.23 203728 SPKA-260 first prev button -->
            <button
              type="button"
              @click="
                page = 1;
                queryPool(false);
              "
              :class="[
                'custom-btn-first-last-paging',
                page == 1 ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="ml-2 pr-2 d-inline">
                <span><i class="fa fa-sm fa-step-backward"></i></span>
              </div>
            </button>
            <button
              type="button"
              @click="changePageByTextbox(-1)"
              :class="[
                'mr-3 custom-btn-first-last-paging',
                page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="ml-2 pr-2 d-inline">
                <span><i class="fa fa-lg fa-caret-left"></i></span>
              </div>
            </button>
            <v-text-field
              v-model="pageEnter"
              hide-details
              dense
              solo
              class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
              @keyup.enter="changePageByTextbox(0)"
            ></v-text-field
            ><label>/ {{ pageCount }}</label>
            <button
              type="button"
              @click="changePageByTextbox(1)"
              :class="[
                'ml-3 custom-btn-first-last-paging',
                page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="mr-2 pl-2 d-inline">
                <span><i class="fa fa-lg fa-caret-right"></i></span>
              </div>
            </button>
            <button
              type="button"
              @click="
                page = pageCount;
                queryPool(false);
              "
              :class="[
                'custom-btn-first-last-paging',
                page == pageCount ? ' v-pagination__navigation--disabled' : '',
              ]"
            >
              <div class="mr-2 pl-2 d-inline">
                <span><i class="fa fa-sm fa-step-forward"></i></span>
              </div>
            </button>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="deviderColor mx-3 mb-2"></v-divider>
    <v-row>
      <v-col class="page-control-bg text-right custom-popup-v3 pa-0 pr-3 pt-2" cols="12">
        <div class="btn-form-control text-right mx-4">
          <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
            <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
            {{ $t('btn.common.close') }}
          </v-btn>
          <v-btn class="btn btn-add btn-popup" @click="onAdd" :disabled="!$auth.manage">
            <!-- <v-icon x-small class="mr-2">fas fa-plus</v-icon> -->
            {{ $t('btn.common.add') }}
          </v-btn>
          <v-btn
            class="btn btn-popup-search btn-popup"
            color="primary"
            @click="onSave"
            :disabled="!$auth.manage"
          >
            <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
            {{ $t('btn.common.save') }}
          </v-btn>
        </div>
      </v-col>
      <!-- </v-row>
  </v-col> -->
    </v-row>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      @select-ok="queryPool"
      :detail="$t('msg.dbBroker.queryPool.saveSuccess')"
    >
    </dialogWindow>
    <dialogWindow
      ref="WarningDialog"
      size="max"
      title="Warning"
      :detail="warnDetail"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="PassSave"
      title="Data changed"
      size="max"
      :detail="$t('msg.dbBroker.queryPool.confirm')"
      color="confirmation"
      :showCancel="true"
      @select-ok="passSave()"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { HotTable } from '@handsontable/vue';
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';

import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert,
} from '@/vue-dlb/utils/sys-util.js';

export default {
  name: 'query-pool-dialog',
  props: [
    'id',
    'title',
    'options',
    'eventCb',
    'selectFile',
    'closeDialog',
    'dragStart',
    'dragEnd',
    'typeDBList',
    'nameDBList',
    'searchNameDBList',
    'searchTypeDBList',
  ],
  components: {
    DialogDrag,
    HotTable,
    dialogWindow,
    IconSvg,
  },
  computed: {},
  data() {
    let self = this;
    return {
      page: 1,
      pageCount: 1,
      totalCount: 0,
      itemsPerPage: 100,
      pageEnter: 1, // 2021.11.26 203728 SPKA-274 modify paging
      rowPerPage: [
        { value: 100, text: 'Show 100' },
        { value: 500, text: 'Show 500' },
        { value: 1000, text: 'Show 1000' },
      ],
      listPage: [{ value: 1, text: 'Page 1' }],
      storeDataPool: [],
      clipboardCache: '',
      hotSettings: {
        copyPaste: true,
        colHeaders: [
          this.$t('tbl.dbBroker.queryPool.queryName'),
          this.$t('tbl.dbBroker.queryPool.dbName'),
          this.$t('tbl.dbBroker.queryPool.type'),
          this.$t('tbl.dbBroker.queryPool.queryText'),
        ],
        columns: [
          { data: 'QR_NM' },
          {
            type: 'dropdown',
            source: self.nameDBList.map((e) => (e = e.text)),
            data: 'QR_DB',
          },
          {
            type: 'dropdown',
            source: self.typeDBList.map((e) => (e = e.text)),
            data: 'QR_TP',
          },
          { data: 'QR_TXT', class: 'custom-trim-text' },
        ],
        rowHeaders: function(index) {
          return self.itemsPerPage * (self.page - 1) + (index + 1);
        },
        beforePaste: function(data, coords) {
          if (data.length > 10000) {
            self.$refs.WarningDialog.dialog = true;
            self.warnDetail = self.$t('msg.dbBroker.queryPool.check10000');
            return false;
          }
          self.totalCount = data.length;
        },
        afterCopy: function(data, coords) {
          self.clipboardCache = data;
        },
        beforeRemoveRow: function(index, amount, physicalRows) {
          physicalRows.forEach((row) => {
            self.removeRow(this.getSourceDataAtRow(row));
            this.getCellMeta(row, 0).valid = true;
            this.getCellMeta(row, 1).valid = true;
            this.getCellMeta(row, 2).valid = true;
            this.getCellMeta(row, 3).valid = true;
          });
        },
        afterChange: function(changes, source) {
          if (!changes) return;
          changes.forEach(([row, prop, oldValue, newValue]) => {
            if (newValue != oldValue) self.updatedRow(this.getSourceDataAtRow(row));
          });
        },
        contextMenu: {
          items: {
            sp1: Handsontable.plugins.ContextMenu.SEPARATOR,
            insert_selected_rows_first: {
              name: 'Insert rows',
              callback: function() {
                const selected = this.getSelected();
                if (!selected) return;

                let newData = [];

                selected.forEach(([row, col, rowEnd, colEnd]) => {
                  if (col === -1) {
                    for (let r = row; r <= rowEnd; r++) {
                      const rowData = this.getSourceDataAtRow(r);
                      if (rowData) {
                        newData.push({
                          QR_NM: rowData.QR_NM,
                          QR_DB: rowData.QR_DB,
                          QR_TP: rowData.QR_TP,
                          QR_TXT: rowData.QR_TXT,
                        });
                      }
                    }
                  } else {
                    for (let r = row; r <= rowEnd; r++) {
                      let rowData = {};
                      for (let c = col; c <= colEnd; c++) {
                        const prop = this.colToProp(c);
                        rowData[prop] = this.getDataAtCell(r, c);
                      }
                      newData.push(rowData);
                    }
                  }
                });
                this.alter('insert_row', 0, newData.length);

                newData.forEach((rowData, index) => {
                  Object.keys(rowData).forEach((key) => {
                    this.setDataAtRowProp(index, key, rowData[key]);
                  });
                });
              },
            },
            remove_row: {},
            sp2: Handsontable.plugins.ContextMenu.SEPARATOR,
            refresh: {
              name: 'Refresh',
              callback: function() {
                self.resetSave();
                self.queryPool();
              },
            },
          },
        },
        width: 1122, // 1200 - 78 => -62 => 1060
        height: 510,
        colWidths: [180, 180, 100, 600],
        rowHeights: 25,
        startRows: 1,
        startCols: 3,
        columnSorting: true,
        autoWrapCol: false,
        invalidCellClassName: 'redCell',
        autoRowSize: true,
      },
      uploadQueryPool: [],
      queryPoolItems: {
        QR_NM: '',
        QR_DB: '',
        QR_TP: '',
        QR_TXT: '',
        R_FROM: 1,
        R_TO: this.itemsPerPage,
        SORT: 'UPDATE',
      },
      deleteList: [],
      updateList: [],
      totalRow: 0,
      warnDetail: '',
    };
  },

  created() {
    this.queryPool();
  },
  watch: {
    pageCount(newVal, oldVal) {
      if (newVal != oldVal) {
        this.listPage = [];
        for (let i = 1; i <= newVal; i++) {
          this.listPage.push({ value: i, text: 'Page ' + i });
        }
      }
    },
    // 2021.11.26 203728 SPKA-274 modify paging
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    // 2021.11.26 203728 SPKA-274 process change page by input textbox
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.queryPool(false);
    },
    onAdd() {
      let _this = this.$refs.hotTableComponent.hotInstance;
      _this.alter('insert_row', 0, 1);
      _this.selectCell(0, 0);
    },
    passSave() {
      this.resetSave();
      this.queryPool(false);
    },
    queryPool(resetPage = true) {
      if (resetPage) this.page = 1;
      if (this.deleteList.length > 0 || this.updateList.length > 0) {
        this.$refs.PassSave.dialog = true;
        return;
      }
      this.queryPoolItems.R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.queryPoolItems.R_TO = this.itemsPerPage * this.page;

      this.$store.dispatch('getQueryPoolList', this.queryPoolItems).then((res) => {
        console.log('--------- Finished to process ----------');
        this.totalCount = res.queryTotal;
        this.pageCount = Math.floor(this.totalCount / this.itemsPerPage);
        if (this.itemsPerPage * this.pageCount !== this.totalCount) this.pageCount += 1;
        res.queryPoolList.map((e) => {
          let index = this.typeDBList.findIndex((r) => r.value === e.QR_TP);
          if (index > -1) e.QR_TP = this.typeDBList[index].text;
          let index2 = this.nameDBList.findIndex((r) => r.value === e.QR_DB);
          if (index2 > -1) e.QR_DB = this.nameDBList[index2].text;
        });

        let _this = this.$refs.hotTableComponent.hotInstance;
        // _this.clear();
        this.resetSave();
        _this.loadData(res.queryPoolList);
        _this.selectCell(0, 0);
        _this.getData().map((e, i) => {
          let item = _this.getSourceDataAtRow(i);
          if (item.QR_USED > 0) {
            _this.getCellMeta(i, 0).readOnly = true;
            _this.getCellMeta(i, 1).readOnly = true;
            _this.getCellMeta(i, 2).readOnly = true;
          }
        });
        _this.render();
        if (res.queryPoolList.length === 0) {
          _this.alter('insert_row', _this.countRows());
          _this.selectCell(_this.countRows() - 1, 'QR_NM');
        }
      });
    },
    isEmpty(value) {
      return !value || !value.replace(/\s/g, '').length ? true : false;
    },
    onSave() {
      this.uploadQueryPool = [];
      console.log('--------- Check data ----------');
      let _this = this.$refs.hotTableComponent.hotInstance;

      if (_this.countRows() > 10000) {
        self.$refs.WarningDialog.dialog = true;
        self.warnDetail = self.$t('msg.dbBroker.queryPool.check10000');
        return;
      }

      let data = _this.getData();
      let _rows = data.length;
      let row = -1,
        col = -1;

      // Check empty
      for (let i = 0; i < _rows; i += 1) {
        // Reset valid
        _this.getCellMeta(i, 0).valid = true;
        _this.getCellMeta(i, 1).valid = true;
        _this.getCellMeta(i, 2).valid = true;
        _this.getCellMeta(i, 3).valid = true;
        // If empty row => pass
        if (_this.isEmptyRow(i)) continue;
        // Check column data
        if (this.isEmpty(data[i][0])) {
          // QR_NM
          _this.getCellMeta(i, 0).valid = false;
          if (col == -1) col = 0;
          if (row == -1) row = i;
        }
        if (this.isEmpty(data[i][1])) {
          // QR_DB
          _this.getCellMeta(i, 1).valid = false;
          if (col == -1) col = 1;
          if (row == -1) row = i;
        }
        if (this.isEmpty(data[i][2])) {
          // QR_TP
          _this.getCellMeta(i, 2).valid = false;
          if (col == -1) col = 2;
          if (row == -1) row = i;
        }
        if (this.isEmpty(data[i][3])) {
          // QR_TXT
          _this.getCellMeta(i, 3).valid = false;
          if (col == -1) col = 3;
          if (row == -1) row = i;
        }
      }

      if (row > -1) {
        _this.render();
        return _this.selectCell(row, col);
      }

      // Check length
      for (let i = 0; i < _rows; i += 1) {
        // Reset valid
        _this.getCellMeta(i, 0).valid = true;
        // If empty row => pass
        if (_this.isEmptyRow(i)) continue;
        // Check column QR_NM data length < 20
        if (data[i][0].length >= 20) {
          // QR_NM
          _this.getCellMeta(i, 0).valid = false;
          if (row == -1) row = i;
        }
      }

      if (row > -1) {
        _this.render();
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.dbBroker.queryPool.qrNmMaxLen');
        return _this.selectCell(row, 0);
      }

      data.map((e, i) => {
        let item = _this.getSourceDataAtRow(i);
        if (!_this.isEmptyRow(i) && !item.QR_ID) {
          this.uploadQueryPool.push({
            SYSSTATUS: 'I',
            CUST_ID: this.$cookies.get('comp-id'),
            OWNR_CUST_ID: this.$cookies.get('ownr-id'),
            QR_ID: '',
            QR_NM: item.QR_NM,
            QR_DB: item.QR_DB,
            QR_TP: item.QR_TP,
            QR_TXT: item.QR_TXT,
          });
        }

        if (_this.isEmptyRow(i) && item.QR_ID) this.removeRow(item);
      });

      // Join delete list
      this.uploadQueryPool = this.uploadQueryPool.concat(this.deleteList);
      // Join update list
      this.uploadQueryPool = this.uploadQueryPool.concat(this.updateList);

      console.log('--------- Check duplicate ----------');

      let arrChk = data.map((e) => {
        return e[0];
      });
      let _index = 0;
      arrChk.findIndex((e, i) => {
        if (arrChk.indexOf(e) != i && !this.isEmpty(e)) {
          _this.getCellMeta(i, 0).valid = false;
          _index = i;
        }
      });

      if (_index > 0) {
        _this.render();
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.dbBroker.queryPool.dup');
        return _this.selectCell(_index, 0);
      }

      // Check save list
      if (this.uploadQueryPool.length == 0) {
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.dbBroker.queryPool.noData');
        return;
      }

      if (data.length > 1000) {
        this.$refs.WarningDialog.dialog = true;
        this.warnDetail = this.$t('msg.dbBroker.queryPool.check1000');
        return;
      }

      //Remove \n before save to database
      data = JSON.stringify(this.uploadQueryPool).replace(/\\n/g, '');
      console.log('--------- savaData ----------', data);

      this.queryPoolItems.R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.queryPoolItems.R_TO = this.itemsPerPage * this.page;
      this.queryPoolItems.queryPoolList = JSON.parse(data);

      this.queryPoolItems.queryPoolList.map((e) => {
        let index = this.typeDBList.findIndex((r) => r.text === e.QR_TP);
        if (index > -1) e.QR_TP = this.typeDBList[index].value;
        let index2 = this.nameDBList.findIndex((r) => r.text === e.QR_DB);
        if (index2 > -1) e.QR_DB = this.nameDBList[index2].value;
      });

      this.$store.dispatch('saveQueryList', this.queryPoolItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.resetSave();
        this.$emit('refreshData');
        this.$refs.successDialog.dialog = true;
      });
    },
    resetSave() {
      this.deleteList = [];
      this.updateList = [];
      this.uploadQueryPool = [];
    },
    removeRow(item) {
      if (item.QR_ID) {
        let record = {
          SYSSTATUS: 'D',
          QR_ID: item.QR_ID,
        };
        // Remove from update list
        this.removeFromUpdateList(record);
        if (this.deleteList.findIndex((element) => element.QR_ID == record.QR_ID) == -1)
          this.deleteList.push(record);
      }
    },
    removeFromUpdateList(record) {
      // If delete record have in update list => remove it from update list
      let index = this.updateList.findIndex((element) => element.QR_ID == record.QR_ID);
      if (index > -1) this.updateList.splice(index, 1);
    },
    updatedRow(item) {
      if (item.QR_ID) {
        let record = {
          SYSSTATUS: 'U',
          CUST_ID: this.$cookies.get('comp-id'),
          OWNR_CUST_ID: this.$cookies.get('ownr-id'),
          QR_ID: item.QR_ID,
          QR_NM: item.QR_NM,
          QR_DB: item.QR_DB,
          QR_TP: item.QR_TP,
          QR_TXT: item.QR_TXT,
        };

        // Check if record in array => remove it
        let index = this.updateList.findIndex((element) => element.QR_ID == record.QR_ID);
        if (index > -1) this.updateList.splice(index, 1);
        // Push new record
        this.updateList.push(record);
      }
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
};
</script>
